import {useEffect, useMemo} from 'react';
import {ISlide} from '../../../incase-domain/slide';
import {IQuestionReportElement} from '../../../incase-domain/elements/question/questionReportElement';
import {
    buildHtmlQuestionReportPayload,
    findHtmlReportQuestion,
    publishHtmlQuestionReport,
} from '../../../incase-domain/elements/html/questionReportSlot';

interface HtmlQuestionReportBridgeProps {
    element: IQuestionReportElement;
    slot: HTMLElement;
    slides: ISlide[];
    slideName: string;
}

function HtmlQuestionReportBridge({element, slot, slides, slideName}: HtmlQuestionReportBridgeProps): null {
    const question = useMemo(() => findHtmlReportQuestion(slides, element, slideName), [element, slideName, slides]);
    const payload = useMemo(() => buildHtmlQuestionReportPayload(question, undefined), [question]);

    useEffect(() => {
        publishHtmlQuestionReport(slot, payload);
    }, [payload, slot]);

    return null;
}

export default HtmlQuestionReportBridge;
